export default {
  benefits: {
    earn_points: 'Sammle Punkte mit jeder Bestellung',
    get_deals: 'Erhalte exklusive Rabatte',
    redeem_points: 'Erhalte Punkte für gratis Essen',
  },
};
